import { omdApi } from 'bus/api';

import { PayloadRequest } from 'types/requestTypes';

import {
  ContractorPumpPriceCreate,
  ContractorPumpPriceDetail,
  ContractorPumpPriceItemList,
  ContractorPumpPriceUpdate,
} from '../ContractorPumpPrice.entity';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getContractorPumpPriceList: builder.query<Array<ContractorPumpPriceItemList>, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorPumpPrice/${data.id}`,
      }),
    }),
    getContractorPumpPriceDetail: builder.query<ContractorPumpPriceDetail, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorPumpPrice/${data.id}/details`,
      }),
    }),
    changeContractorPumpPrice: builder.mutation<void, ContractorPumpPriceUpdate>({
      query: (data) => ({
        url: `/v1/ContractorPumpPrice/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createContractorPumpPrice: builder.mutation<void, ContractorPumpPriceCreate>({
      query: (data) => ({
        url: '/v1/ContractorPumpPrice',
        method: 'POST',
        body: data,
      }),
    }),
    deleteContractorPumpPrice: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorPumpPrice/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeContractorPumpPriceMutation,
  useCreateContractorPumpPriceMutation,
  useDeleteContractorPumpPriceMutation,
  useGetContractorPumpPriceDetailQuery,
  useGetContractorPumpPriceListQuery,
  useLazyGetContractorPumpPriceDetailQuery,
  useLazyGetContractorPumpPriceListQuery,
} = request;
